import { render, staticRenderFns } from "./DiseaseBankFood.vue?vue&type=template&id=19f37b5d&scoped=true"
import script from "./DiseaseBankFood.vue?vue&type=script&lang=js"
export * from "./DiseaseBankFood.vue?vue&type=script&lang=js"
import style0 from "./DiseaseBankFood.vue?vue&type=style&index=0&id=19f37b5d&prod&scoped=true&lang=css"
import style1 from "./DiseaseBankFood.vue?vue&type=style&index=1&id=19f37b5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f37b5d",
  null
  
)

export default component.exports